<template>
  <div class="mt-10 text-center w-full"
    :class="$route.params.slug ? 'w-11/12 lg:w-3/4 mx-auto': ''">
    <div class="my-5 py-3 pl-2 text-xl lg:text-3xl font-bold w-full">
      <h1 class="w-full mx-auto uppercase text-left">
        Masterclasses
      </h1>
    </div>
    <masterclass-card
      class="w-2/3 mb-8 hidden md:block"
      v-for="masterclass in masterclasses"
      :key="masterclass.id"
      :masterclass="masterclass" />
    <masterclass-card-mobile
      class="w-full mb-8 block md:hidden"
      v-for="masterclass in masterclasses"
      :key="'m_mobile_'+masterclass.id"
      :masterclass="masterclass" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTeacherMasterclasses } from '@/services/TeacherService';
import MasterclassCard from '../masterclasses/MasterclassCard.vue';
import MasterclassCardMobile from '../masterclasses/MasterclassCardMobile.vue';

export default {
  components: { MasterclassCard, MasterclassCardMobile },

  data() {
    return {
      masterclasses: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getMasterclasses();
  },

  methods: {
    getMasterclasses() {
      getTeacherMasterclasses(this.$route.params.slug ? this.$route.params.slug : this.user.slug)
        .then(({ data }) => {
          this.masterclasses = data;
        });
    },
  },
};
</script>
